<template>
  <div class="homeContent">
    <template v-if="this.userAuth.show_summary_data">
      <summary-com></summary-com>
    </template>
    <template v-if="this.userAuth.show_summary_executor ||this.userAuth.show_summary_sale">
      <MySummary/>
    </template>
  </div>
</template>

<script>
// import summary from "../components/summary/indexOld";
import summary from "@/components/summary/MyDashBoard";//重写20220124
import MySummary from "@/components/summary/myDashboard/MySummary";

export default {
  name: "home",
  components: {
    MySummary,
    "summary-com": summary
  },
  data() {
    return {
      dialogTableVisible: false,
      dialogCustomerContactVisible: false,
      recordForm: {
        follow_timestamp: "",
        record_content: "",
        customer_id: ""
      },
      permission: [], //permission: summary  excu  sale
      summaryData: {},
      //汇总销售
      saleForm: {
        name: ""
      },
      params: {
        page: 1,
        per_page: 10,
        total: 100
      },
      theadData: [],
      saleData: [],

      //汇总执行
      excuForm: {
        name: ""
      },
      excuparams: {
        page: 1,
        per_page: 8,
        total: 100
      },
      excutheadData: [],
      excuData: [],

      //销售-客户列表
      customerForm: {
        name: ""
      },
      customerData: [],
      followRecord: [],
      theadcusData: [],
      cusparams: {
        page: 1,
        per_page: 8,
        total: 100
      },
      cusSort: {
        order: "",
        prop: ""
      },

      //执行-未执行订单
      excuOrderData: [],
      excuOrdertheadData: [],
      excuOrderForm: {
        name: ""
      },
      excuOrderParams: {
        page: 1,
        per_page: 8,
        total: 100
      },
      excuSort: {
        order: "",
        prop: ""
      },

      //已执行未结款
      exUnsettledForm: {
        name: "",
        bool_exec: "1"
      },
      exUnsettledData: [],
      exUnsettledtheadData: [],
      exUnsettledparams: {
        page: 1,
        per_page: 8,
        total: 100
      },
      exUnsettledSort: {
        order: "",
        prop: ""
      },

      // 未结款订单
      unsettledFundsForm: {
        name: "",
        bool_exec: "2"
      },
      unsettledFundsData: [],
      unsettledFundsTheadData: [],
      unsettledFundsParams: {
        page: 1,
        per_page: 8,
        total: 100
      },
      unsettledFundsSort: {
        order: "",
        prop: ""
      },

      follow_record: [],

      month: 1,
      currentMonth: {},
      lastMonth: {},
      currentYear: {},
      contactCustomer: '',
      contactCustomerData: [],
    };
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  }
};
</script>
<style scoped>
.homeContent {
  background: #f3f3f3;
  padding: 10px 16px;
  /*margin-top: 70px;*/
  box-sizing: border-box;
  min-height: calc(100vh - 70px);
}
</style>
